<div class="subscribe-page-main">
  <div class="subscribe-page-inner">
    <h2 class="subscribe-page-title mr-0">Add API</h2>
    <div class="subscribe-page-form-div">
      <kp-api-subscribe [apiData]="selectedApiDetails" [applicationsData]="applicationsData"> </kp-api-subscribe>
    </div>
  </div>
</div>
